import angular from 'angular'
import uiRouter from 'angular-ui-router'
import ngCookies from 'angular-cookies'
import ngSanitize from 'angular-sanitize'
import ngAnimate from 'angular-animate'
import ngLoadingBar from 'angular-loading-bar'
import './common';
import './components'
import './layout'
import './services'

import AppComponent from './app.component'
import LanguageLoaderService from './config/language-loader.service';

import 'normalize.css'
import 'angular-ui-bootstrap'
import 'angular-translate'
import 'angular-translate-loader-static-files'
import 'angular-barcode'
import 'angular-moment-picker'
import 'angular-drag-and-drop-lists'
import 'angular-ui-bootstrap-datetimepicker'
import 'ui-select'
import 'angular-ui-calendar'
import 'bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'angular-daterangepicker'
import 'fullcalendar'
import 'isteven-angular-multiselect/isteven-multi-select.js'
import 'isteven-angular-multiselect/isteven-multi-select.css'

import 'bootstrap-loader'
import 'angular-bootstrap-switch'
import 'bootstrap-switch'
import 'ngmap'
import 'ng-currency'
import 'angular-input-masks'
import 'ng-toast'
import 'ng-toast/dist/ngToast.min.css'

import moment from 'moment';
import _ from 'lodash';

import constants from './config/app.constants'
import appConfig from './config/app.config'
import appRun from './config/app.run'
import AuthFactory from './common/auth/auth.factory'

import './assets/favicons/favicons'
import 'leaflet/dist/leaflet.js'
import 'leaflet/dist/leaflet.css'

import './assets/lib/leaflet-awesome-marker/leaflet_awesome_number_markers.js'
import './assets/lib/leaflet-awesome-marker/leaflet_awesome_number_markers.css'
import 'moment-timezone/builds/moment-timezone-with-data.js'
import 'angular-timer/dist/angular-timer.js'
import 'leaflet-boundary-canvas/src/BoundaryCanvas.js'
import 'leaflet-draw/dist/leaflet.draw.js'
import 'ng-idle/angular-idle.js'

window.moment = moment;

angular.module('app', [
    uiRouter,
    ngCookies,
    ngSanitize,

    'ngAnimate',
    'angular-loading-bar',
    'pascalprecht.translate',
    'ng-currency',

    'ui.bootstrap',
    'ui.bootstrap.tpls',
    'ui.bootstrap.datetimepicker',
    'ui.bootstrap.popover',
    'ui.select',
    'ui.calendar',
    'ui.utils.masks',
    'daterangepicker',

    'frapontillo.bootstrap-switch',
    'moment-picker',
    'dndLists',
    "isteven-multi-select",
    'ngToast',

    'angular-barcode',

    'app.common',
    'app.components',
    'app.layout',
    'app.services',
    'timer',
    'ngIdle'
])
    .factory('LanguageLoaderService', LanguageLoaderService)

    .constant('AppConstants', constants)

    .config(appConfig)

    .run(appRun)

    .component('app', AppComponent)


// WEBPACK FOOTER //
// ./client/app/app.js